import type { Dispatch } from 'react';
import { ApiV2 } from 'src/api/apiv2';
import { HEADERS } from 'src/constants/headers';
import type { TAPIOptions } from 'src/constants/apis/types';
import { SET_LOADING } from 'src/contexts/types';
import { handleError } from 'src/contexts/utils/handleError';
import { GET_WARBOX_CONVERSATIONS } from '../constants/actions';
import type { TWarboxConversationActionTypes } from '../types';
import type { IConversation } from 'src/interfaces/conversation';

export type TGetConversationsQuery = {
    page?: number;
    limit?: number;
    sort?: string;
    filters?: Record<string, unknown>;
};

export const buildConversationsRequestBody = (
    query: TGetConversationsQuery = {},
    options: TAPIOptions = {}
) => ({
    page: query.page ?? 1,
    limit: query.limit ?? 20,
    sort: query.sort ?? '-lastMessageAt',
    ...query.filters,
    ...(options.select ? { select: options.select } : {}),
    ...(options.populate?.length ? { populate: options.populate } : {}),
});

export const getConversations = async (
    dispatch: Dispatch<TWarboxConversationActionTypes>,
    query: TGetConversationsQuery = {},
    options: TAPIOptions = {
        isReadPermissionNecessary: false,
        select: '',
        populate: [],
    }
): Promise<void> => {
    dispatch({ type: SET_LOADING });

    try {
        const config = HEADERS({
            isReadPermissionNecessary:
                options.isReadPermissionNecessary ?? false,
        });
        const res = await ApiV2.post(
            '/conversations',
            buildConversationsRequestBody(query, options),
            config
        );

        const conversations: IConversation[] =
            res.data?.results ?? res.data?.data ?? [];
        const total =
            res.data?.total ??
            res.data?.pagination?.total ??
            res.data?.count ??
            conversations.length;

        dispatch({
            type: GET_WARBOX_CONVERSATIONS,
            payload: { conversations, total },
        });
    } catch (error) {
        dispatch({
            type: GET_WARBOX_CONVERSATIONS,
            payload: { conversations: [], total: 0 },
        });

        if (error instanceof Error) dispatch(handleError(error));
    }
};
